"use client"

import { Zap, UserX, MapPin } from "lucide-react"

import { cn } from "@/lib/utils"

interface SocialProofBannerProps {
  className?: string
}

export function SocialProofBanner({ className }: SocialProofBannerProps) {
  const items = [
    { icon: Zap, text: "Instant results" },
    { icon: UserX, text: "No signup required" },
    { icon: MapPin, text: "All 50 states" },
  ]

  return (
    <div className={cn("flex flex-wrap items-center justify-center gap-4 sm:gap-6", className)}>
      {items.map((item) => (
        <div key={item.text} className="flex items-center gap-1.5">
          <span className="flex items-center justify-center w-7 h-7 rounded-full bg-green-100 text-green-600">
            <item.icon className="w-3.5 h-3.5" />
          </span>
          <span className="text-sm font-medium text-gray-700">{item.text}</span>
        </div>
      ))}
    </div>
  )
}
